import { v4 as uuidv4 } from 'uuid';
import { callAPI, callServiceAPI } from './ApiUtils';
var dmpCoreWebServicesPrefix = "https://api.dmp.appmachine.in";

export function bePartnerAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/bepartner", "POST", payload, successCallBack, failuerCallback);
}export function addMemberAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/addmember", "POST", payload, successCallBack, failuerCallback);
}export function placeOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/placeorder", "POST", payload, successCallBack, failuerCallback);
}export function getMLMuserAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getmlmuser", "POST", payload, successCallBack, failuerCallback);
}export function inviteeLoginSuccessAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/inviteeloginsuccess", "PUT", payload, successCallBack, failuerCallback);
}export function updateUserNameAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/username", "PUT", payload, successCallBack, failuerCallback);
}export function orderTomlmAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/ordertomlm", "POST", payload, successCallBack, failuerCallback);
}export function confirmPaymentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/confirmpayment", "POST", payload, successCallBack, failuerCallback);
}export function initPartnerPaymentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/initpartnerpayment", "POST", payload, successCallBack, failuerCallback);
}export function confirmPartnerPaymentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/confirmpartnerpayment", "PUT", payload, successCallBack, failuerCallback);
}export function initPartnershipAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/initpartnership", "POST", payload, successCallBack, failuerCallback);
}export function applyCouponAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/applycoupon", "PUT", payload, successCallBack, failuerCallback);
}export function removeCouponAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/removecoupon", "PUT", payload, successCallBack, failuerCallback);
}export function calculateCreditAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/calculatecredit", "POST", payload, successCallBack, failuerCallback);
}export function getPaymentDetailsAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getpaymentdetails", "POST", payload, successCallBack, failuerCallback);
}export function updatePaymentStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/updatepaymentstatus", "PUT", payload, successCallBack, failuerCallback);
}export function getTransactionListAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getransactionlist", "POST", payload, successCallBack, failuerCallback);
}export function reconfirmPaymentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/reconfirmpayment", "POST", payload, successCallBack, failuerCallback);
}export function getAllPaymentOrdersAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getallpaymentorders", "POST", payload, successCallBack, failuerCallback);
}export function refreshRazorAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/refreshrazor", "POST", payload, successCallBack, failuerCallback);
}export function ConfirmMembershipAgainstOrderIdAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/confirmmembershipagainstorderid", "POST", payload, successCallBack, failuerCallback);
}export function getStatementAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getstatement", "POST", payload, successCallBack, failuerCallback);
}export function initTransferReqAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/inittransferreq", "POST", payload, successCallBack, failuerCallback);
}export function getTransferreqInfoAPI(id, successCallBack, failuerCallback){

    callAPI(dmpCoreWebServicesPrefix+"/transferreq/"+id+"/transferreqInfo", "GET", {}, successCallBack, failuerCallback);
}export function addFundAccountAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/addfundaccount", "POST", payload, successCallBack, failuerCallback);
}export function getFundAccountAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getfundaccount", "POST", payload, successCallBack, failuerCallback);
}export function validateFundAccountAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/validatefundaccount", "POST", payload, successCallBack, failuerCallback);
}export function addBeneficiaryAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/addbeneficiary", "POST", payload, successCallBack, failuerCallback);
}export function updateKYCAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/updatekyc", "POST", payload, successCallBack, failuerCallback);
}export function getKYCAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getkyc", "POST", payload, successCallBack, failuerCallback);
}export function getAddbenefreqAPI(id, successCallBack, failuerCallback){

    callAPI(dmpCoreWebServicesPrefix+"/addbenefreq/"+id, "GET", {}, successCallBack, failuerCallback);
}export function getAddbenefreqsByAuthidAPI(authid, successCallBack, failuerCallback){

    callAPI(dmpCoreWebServicesPrefix+"/addbenefreqs/authid/"+authid+"/authid", "GET", {}, successCallBack, failuerCallback);
}export function updateFundAccountAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/updatefundaccount", "PUT", payload, successCallBack, failuerCallback);
}export function dispatchOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/dispatchorder", "PUT", payload, successCallBack, failuerCallback);
}export function updateAddressAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/updateaddress", "POST", payload, successCallBack, failuerCallback);
}export function sendReminderToInviteeAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/sendremindertoinvitee", "POST", payload, successCallBack, failuerCallback);
}export function confirmPartnershipByMLMorderIdAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/confirmpartnershipbymlmorderid", "PUT", payload, successCallBack, failuerCallback);
}export function isMLMAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/ismlm", "POST", payload, successCallBack, failuerCallback);
}export function approveCreditAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/approvecredit", "PUT", payload, successCallBack, failuerCallback);
}export function processRazorWebhookAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/processrazorwebhook", "POST", payload, successCallBack, failuerCallback);
}export function approveCreditTransferReqAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/approvecredittransferreq", "PUT", payload, successCallBack, failuerCallback);
}export function getFundAccountByUserIdAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getfundaccountbyuserid", "POST", payload, successCallBack, failuerCallback);
}export function markCreditTransferDoneAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/markcredittransferdone", "PUT", payload, successCallBack, failuerCallback);
}
export function getWalletBalanceAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(dmpCoreWebServicesPrefix+"/getwalletbalance", "POST", payload, successCallBack, failuerCallback);
}
